export const STORE_SELECTOR_PREFIX = "StoreSelector";

export const STORE_SELECTOR_CLASSES = {
  drawerContent: `${STORE_SELECTOR_PREFIX}-drawerContent`,
};

export const STORE_SELECTOR_TITLE_ID = "store-selector-modal-title";
